import { useEffect } from 'react';
import { useUnleashContext } from '@alchemer/unleash';
import { useBoundStore } from '@/store';
import type { AppAuthContext } from '@/types/auth';

export function useUnleashUserContext(auth: AppAuthContext) {
  const updateContext = useUnleashContext();
  const selectedRegion = useBoundStore((s) => s.selectedRegion);

  useEffect(() => {
    if (!auth.user?.sub) return;
    updateContext({
      userId: auth.user.sub,
      properties: {
        ...(auth.user.email && { email: auth.user.email }),
        ...(auth.user.name && { name: auth.user.name }),
        region: selectedRegion,
      },
    });
  }, [auth.user?.sub, auth.user?.email, auth.user?.name, selectedRegion, updateContext]);
}
